import type { Confidence } from "../domain/types";

const qualityLabel: Record<Confidence, string> = {
  high: "高",
  medium: "中",
  low: "低",
};

interface EstimateQualityProps {
  level: Confidence;
  subject: "降雨" | "风力";
}

export function EstimateQuality({ level, subject }: EstimateQualityProps) {
  const label = `${subject}估算参考程度${qualityLabel[level]}`;
  return (
    <span
      aria-label={label}
      className="estimate-quality"
      data-quality={level}
      role="img"
      title={label}
    />
  );
}
